<template>
	<el-dialog
		title="导入结果"
		:visible.sync="dialogVisible"
		width="500px"
		:before-close="handleClose"
	>
		<div class="import-result">
			<div class="result-content" v-html="resultData"></div>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="handleClose">确定</el-button>
		</span>
	</el-dialog>
</template>

<script>
export default {
	props: {
		isDialog: {
			type: Boolean,
			default: false
		},
		resultData: {
			type: String,
			default: ''
		}
	},
	computed: {
		dialogVisible: {
			get() {
				return this.isDialog
			},
			set(val) {
				this.$emit('handleClose')
			}
		}
	},
	methods: {
		handleClose() {
			this.$emit('handleClose')
		}
	}
}
</script>

<style lang="scss" scoped>
.import-result {
	.result-content {
		padding: 16px;
		background: #f5f7fa;
		border-radius: 4px;
		max-height: 300px;
		overflow-y: auto;
		line-height: 1.8;
		color: #606266;
	}
}
</style>
